var path = '/formViewer/component/sectionPlaceholder.tpl.html';
var html = "<div class=\"formSection\"\n     ui-hide-empty-section></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;